var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main","sticky-container":""}},[_c('navigation'),_c('router-view'),_c('sui-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }